import { createCrudActions } from "../utils/crudGenerator";

const formatConsultations = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.title}`,
		value: item._id,
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const {
	fetch: fetchConsultations,
	create: createConsultation,
	update: updateConsultation,
	delete: deleteConsultations,
} = createCrudActions("CONSULTATION", "Consulta", formatConsultations);
